// Front-end only: outcome of validating one phone entry; each non-valid value has its own message.

export const PhoneVerdict = {
  VALID: 'valid',
  EMPTY: 'empty',
  INVALID_CHARACTERS: 'invalidCharacters',
  INCOMPLETE: 'incomplete',
  INVALID_NUMBER: 'invalidNumber'
} as const satisfies Record<string, string>

export type PhoneVerdict = (typeof PhoneVerdict)[keyof typeof PhoneVerdict]
